import Vue from 'vue'
import Router from 'vue-router'

// ===== 页面组件导入 =====
import Login from '@/views/index/Login.vue'
import AdminLogin from '@/views/index/AdminLogin.vue'
import Register from '@/views/index/Register.vue'
import OrganizationApplication from '@/views/index/OrganizationApplication.vue'
import ForgotPassword from '@/views/index/ForgotPassword.vue'

import AccountManagement from '@/views/account/AccountManagement.vue'
import RoleManagement from '@/views/home/Dashboard.vue' // 注意：这个命名有点误导，建议改名
import Product from '@/views/product/Product.vue'
import Category from '@/views/category/Category.vue'
import Order from '@/views/order/Order.vue'
import Statistics from '@/views/statistics/Statistics.vue'
import Settings from '@/views/system/Settings.vue'
import MobileSettings from '@/views/system/MobileSettings.vue'
import SystemRoleSettings from '@/views/system/SystemRoleSettings.vue'
import SystemParam from '@/views/system/SystemParam.vue'
import UsageLog from '@/views/system/UsageLog.vue'
import VoiceSettings from '@/views/system/VoiceSettings.vue'

import Shop from "@/views/shop/Shop.vue"
import ShopDecoration from "@/views/shop/ShopDecoration.vue"

import Profile from '@/views/profile/Profile.vue'
import Home from '@/views/home/home.vue' // 主布局或首页容器

import Friends from '@/views/friends/index.vue'
import HotWords from '@/views/hotWords/index.vue'
import VoiceSetting from '@/views/voiceSetting/index.vue'
import RoomDesign from '@/views/roomDesign/index.vue'

import store from "@/store"

Vue.use(Router)

/**
 * 基础路由（无需登录）
 */
const constantRoutes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { guestOnly: true, title: '登录' }
    },
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: { guestOnly: true, title: '管理员登录' }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: { guestOnly: true, title: '注册' }
    },
    {
        path: '/organizationApplication',
        name: 'OrganizationApplication',
        component: OrganizationApplication,
        meta: { guestOnly: true, title: '机构申请' }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: { guestOnly: true, title: '忘记密码' }
    }
]

/**
 * 认证后路由（需要登录）
 * 可以用嵌套路由组织主界面
 */
export const asyncRoutes = [
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true, title: '首页' },
        redirect: '/home/createRole',
        children: [
            {
                path: 'createRole',
                name: 'CreateRole',
                component: () => import('@/views/createRole/index.vue'),
                meta: { requiresAuth: true, title: '创建新角色' }
            },
            {
                path: 'edit-role/:id',
                name: 'EditRole',
                component: () => import('@/views/createRole/index.vue'),
                meta: {
                    title: '编辑角色',
                    requiresAuth: true,
                    mode: 'edit'
                }
            },
            {
                path: 'myModels',
                name: 'MyModels',
                component: () => import('@/views/models/index.vue'),
                meta: { requiresAuth: true, title: '我的角色库' }
            },
            {
                path: 'friends',
                name: 'Friends',
                component: Friends,
                meta: { requiresAuth: true, title: '我的好友' }
            },
            {
                path: 'voiceModels',
                name: 'HotWords',
                component: HotWords,
                meta: { requiresAuth: true, title: '热词设定' }
            },
            {
                path: 'voiceSetting',
                name: 'VoiceSetting',
                component: VoiceSetting,
                meta: { requiresAuth: true, title: '声音克隆' }
            },
            {
                path: 'myVoiceLibrary',
                name: 'MyVoiceLibrary',
                component: () => import('@/views/myVoiceLibrary/index.vue'),
                meta: { requiresAuth: true, title: '我的声音库' }
            },
            {
                path: 'roomDesign',
                name: 'RoomDesign',
                component: RoomDesign,
                meta: { requiresAuth: true, title: '房间设计' }
            },
            {
                path: 'agentPoints',
                name: 'AgentPoints',
                component: () => import('@/views/agentPoints/index.vue'),
                meta: { requiresAuth: true, title: 'Agent点数' }
            },
            {
                path: 'account-management',
                name: 'AccountManagement',
                component: AccountManagement,
                meta: { requiresAuth: true, title: '用户管理' }
            },
            {
                path: 'roleManagement',
                name: 'RoleManagement',
                component: RoleManagement,
                meta: { requiresAuth: true, title: '角色管理' }
            },
            {
                path: 'category',
                name: 'Category',
                component: Category,
                meta: { requiresAuth: true, title: '商品分类' }
            },
            {
                path: 'shop',
                name: 'Shop',
                component: Shop,
                meta: { requiresAuth: true, title: '店铺管理' }
            },
            {
                path: 'shop-decoration',
                name: 'ShopDecoration',
                component: ShopDecoration,
                meta: { requiresAuth: true, title: '店铺装修' }
            },
            {
                path: 'product',
                name: 'Product',
                component: Product,
                meta: { requiresAuth: true, title: '产品管理' }
            },
            {
                path: 'order',
                name: 'Order',
                component: Order,
                meta: { requiresAuth: true, title: '订单管理' }
            },
            {
                path: 'statistics',
                name: 'Statistics',
                component: Statistics,
                meta: { requiresAuth: true, title: '数据统计' }
            },
            {
                path: 'settings',
                name: 'Settings',
                component: Settings,
                meta: { requiresAuth: true, title: '系统设置' }
            },
            {
                path: 'systemRoles',
                name: 'SystemRoleSettings',
                component: SystemRoleSettings,
                meta: { requiresAuth: true, requiresAdmin: true, title: '系统角色设置' }
            },
            {
                path: 'mobileSettings',
                name: 'MobileSettings',
                component: MobileSettings,
                meta: { requiresAuth: true, title: '移动端设置' }
            },
            {
                path: 'systemParam',
                name: 'SystemParam',
                component: SystemParam,
                meta: { requiresAuth: true, requiresAdmin: true, title: '系统参数' }
            },
            {
                path: 'usageLog',
                name: 'UsageLog',
                component: UsageLog,
                meta: { requiresAuth: true, requiresAdmin: true, title: '使用日志' }
            },
            {
                path: 'timePlan',
                name: 'TimePlanManage',
                component: () => import('@/views/system/TimePlanManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '时长套餐' }
            },
            {
                path: 'topicManage',
                name: 'TopicManage',
                component: () => import('@/views/system/TopicManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '话题库' }
            },
            {
                path: 'promptManage',
                name: 'PromptManage',
                component: () => import('@/views/system/PromptManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: 'Prompt 模板' }
            },
            {
                path: 'behaviorRule',
                name: 'BehaviorRuleManage',
                component: () => import('@/views/system/BehaviorRuleManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '行为规则' }
            },
            {
                path: 'usagePlan',
                name: 'UsagePlanManage',
                component: () => import('@/views/system/PlanManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '用量套餐' }
            },
            {
                path: 'deviceInfo',
                name: 'DeviceInfoManage',
                component: () => import('@/views/system/DeviceInfoManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '设备信息' }
            },
            {
                path: 'memoryModule',
                name: 'MemoryModuleManage',
                component: () => import('@/views/system/MemoryModuleManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '记忆模块' }
            },
            {
                path: 'userManage',
                name: 'UserManage',
                component: () => import('@/views/system/UserManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '平台用户' }
            },
            {
                path: 'platformOrder',
                name: 'PlatformOrderManage',
                component: () => import('@/views/system/PlatformOrderManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '平台订单' }
            },
            {
                path: 'activationCode',
                name: 'ActivationCodeManage',
                component: () => import('@/views/system/ActivationCodeManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '激活码管理' }
            },
            {
                path: 'servicePrice',
                name: 'ServicePriceManage',
                component: () => import('@/views/system/ServicePriceManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '服务单价' }
            },
            {
                path: 'rechargePackage',
                name: 'RechargePackageManage',
                component: () => import('@/views/system/RechargePackageManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '充值包管理' }
            },
            {
                path: 'walletTransaction',
                name: 'WalletTransactionManage',
                component: () => import('@/views/system/WalletTransactionManage.vue'),
                meta: { requiresAuth: true, requiresAdmin: true, title: '点数流水' }
            },
            {
                path: 'voiceSettings',
                name: 'VoiceSettings',
                component: VoiceSettings,
                meta: { requiresAuth: true, requiresAdmin: true, title: '声音克隆' }
            },


            {
                path: 'profile',
                name: 'Profile',
                component: Profile,
                meta: { requiresAuth: true, title: '个人中心' }
            },
            {
                path: 'contact',
                name: 'ContactUs',
                component: () => import('@/views/contact/index.vue'),
                meta: { requiresAuth: true, title: '联系我们' }
            }
        ]
    }
]

/**
 * 404
 */
export const fallbackRoute = {
    path: '*',
    redirect: '/login'
}

const router = new Router({
    mode: 'history',
    routes: [...constantRoutes, ...asyncRoutes, fallbackRoute]
})

// ======= 路由守卫 =======
router.beforeEach((to, from, next) => {
    const isAuthenticated = !!store.state.token

    // 1. 如果目标页需要登录，但用户未登录 → 跳转到登录页
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        return next({
            path: '/login',
            query: { redirect: to.fullPath } // 登录后跳回来
        })
    }

    // 2. 如果是仅游客可访问的页面（如登录、注册），但已登录 → 跳转到首页
    if (to.meta.guestOnly && isAuthenticated) {
        return next({ path: '/home' })
    }

    // 3. 仅管理员可访问的页面
    if (to.matched.some(record => record.meta.requiresAdmin) && !store.state.isAdmin) {
        return next({ path: '/home/createRole' })
    }

    // 4. 正常放行
    next()
})

// ======= 可选：动态更新标题 =======
router.afterEach((to) => {
    document.title = to.meta.title || '后台管理系统'
})

export default router
